import TableText from "@/components/table/TableText";
import _ from 'lodash';
import moment from "moment";
import React from "react";
import { numConvert, calculation } from '@/method';

const totalIndex = [10];
const monthList = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
export const fillData = ({ table1, table2, table3 }, { year, date, budget, budgetNext, ftwo, fthree, fone, month }) => {
    // const correspond = [0, 1, 2, 5, 8, 11, 12, 16, 19, 24];
    const correspond = [0, 1, 2, 6, 10, 11, 14, 18, 22, 27];
    // 下月预测、预算填充 
    Object.entries(correspond).forEach(item => {
        const forecastName = month < 12 ? monthList[month] : 'forecast';
        const budgetData = month < 12 ? budget : budgetNext;
        table1[item[0]].forecast = _.get(fone, `${item[1]}.${forecastName}_rn`, 0);
        table1[item[0]].budget = _.get(budgetData, `${item[1]}.${monthList[~~(moment(date).add(1, 'month').format('M') - 1)]}_rn`, 0);

        const forecast2Name = month == 12 ? 'feb' : month < 11 ? monthList[~~(~~month + 1)] : 'forecast';
        const budget2Data = month < 11 ? budget : budgetNext;
        table2[item[0]].forecast = _.get(ftwo, `${item[1]}.${forecast2Name}_rn`, 0);
        table2[item[0]].budget = _.get(budget2Data, `${item[1]}.${monthList[~~(moment(date).add(2, 'month').format('M') - 1)]}_rn`, 0);

        const forecast3Name = month < 10 ? monthList[~~(~~month + 2)] : month == 10 ? 'forecast' : month == 11 ? 'feb' : 'mar';
        const budget3Data = month < 10 ? budget : budgetNext;
        table3[item[0]].forecast = _.get(fthree, `${item[1]}.${forecast3Name}_rn`, 0);
        table3[item[0]].budget = _.get(budget3Data, `${item[1]}.${monthList[~~(moment(date).add(3, 'month').format('M') - 1)]}_rn`, 0);
    });

    return { table1: compute(table1), table2: compute(table2), table3: compute(table3) };
}

export const compute = (data) => {
    ['otb', 'trend', 'forecast', 'budget'].forEach(name => {
        data[10][name] = data.reduce((a, b, i) => {
            if (i < 10) a += numConvert(b[name]);
            return a
        }, 0).toFixed(2);
    });
    return _.cloneDeep(data);
}

export const columns = (onChange, date, print, table) => {
    let month = moment(date).add(1, 'month').format('M');
    let sqlName = '_4_2_2_new';
    if (table == 'table2') {
        sqlName = '_4_2_2_new_2';
        month = moment(date).add(2, 'month').format('M');
    }
    if (table == 'table3') {
        sqlName = '_4_2_2_new_3';
        month = moment(date).add(3, 'month').format('M');
    }
    return [
        {
            title: <div>No.<br />序号</div>,
            dataIndex: 'sort',
            key: 'sort',
            align: "center",
            width: 60,
            render: (text, record, index) => {
                const props = {
                    text: totalIndex.includes(index) ? '' : ~~(index + 1),
                    index,
                    type: 'text',
                    name: "sort",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['No. 序号'],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        {
            title: <div>Market Segment<br />细分市场</div>,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 250,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                    compared: {
                        title: ['Market Segment<br />细分市场'],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        {
            title: <div>On-hand bookings<br />在手预订间夜</div>,
            align: "center",
            children: [{
                title: `${month}月 OTB`,
                dataIndex: 'otb',
                key: 'otb',
                align: "center",
                width: 120,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: totalIndex.includes(index) ? 'number' : 'inputNumber',
                        name: "otb",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['On-hand bookings<br />在手预订间夜', `${month}月 OTB`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: <div>Rnts Pickup from last Mth<br />30天间夜+/-</div>,
            align: "center",
            children: [{
                title: `预订趋势`,
                dataIndex: 'trend',
                key: 'trend',
                align: "center",
                width: 120,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: totalIndex.includes(index) ? 'number' : 'inputNumber',
                        name: "trend",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Rnts Pickup from last Mth<br />30天间夜+/-', `预订趋势`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: `Target Room Nts 目标间夜`,
            children: [{
                title: `${month}月预测`,
                dataIndex: 'forecast',
                key: 'forecast',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "forecast",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Target Room Nts 目标间夜', `预测`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }, {
                title: `${month}月预算`,
                dataIndex: 'budget',
                key: 'budget',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    const props = {
                        text,
                        index,
                        type: 'number',
                        name: "budget",
                        onChange,
                        totalIndex,
                        compared: {
                            title: ['Target Room Nts 目标间夜', `预算`],
                            record,
                            sqlName
                        }
                    };
                    return <TableText data={props} />
                }
            }]
        },
        {
            title: <div>Key Strategy<br />主要策略</div>,
            dataIndex: 'strategy',
            key: 'strategy',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: totalIndex.includes(index) ? 'text' : 'textArea',
                    name: "strategy",
                    onChange,
                    totalIndex,
                    minRows: 2,
                    compared: {
                        title: [`Key Strategy<br />主要策略`],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        },
        {
            title: <div>Action Plans<br />行动计划</div>,
            dataIndex: 'plans',
            key: 'plans',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: totalIndex.includes(index) ? 'text' : 'textArea',
                    name: "plans",
                    onChange,
                    totalIndex,
                    minRows: 2,
                    compared: {
                        title: [`Action Plans<br />行动计划`],
                        record,
                        sqlName
                    }
                };
                return <TableText data={props} />
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4new/4.2/4.2.2/compute.js